
import { api, handleToast } from "./config";



export async function login(data) {
  return  api.post('login', data, {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        }
    }).then(res => {return res})
    .catch((error) => {
        if (error.request.status === 401) {
            localStorage.removeItem('login')
        }
        handleToast('error', error.response.data.message)
    })
}
export async function sendOtp(data) {
  return  api.post('send-otp', data, {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        }
    }).then(res => {return res})
    .catch((error) => {
        if (error.request.status === 401) {
            localStorage.removeItem('login')
        }
    })
}